import React from 'react';

const Coming = () => {
    return (
        <div className='text-center'>
            <iframe title='coming soon' src="https://embed.lottiefiles.com/animation/102335" className='mx-auto'></iframe>
        </div>
    );
};

export default Coming;